import axiosClient from "../../../utils/axios";
import { Organization } from "../types/organization.types";
import { ApiResponse } from "../../../types/api.types";

export const getOrganization = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.post<ApiResponse<Organization>>(
      `/organization/view`,
      {
        id,
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Organization : ", err);
    throw err;
  }
};
